import logger from '~/utils/logger'

type FeedbackStorageValue = {
  feedbackShown?: boolean
  workoutComplete?: boolean
  singleGameplayComplete?: boolean
}

const FeedbackStorageKey = 'l2_feedback'

const isStorageAvailable = (): boolean => typeof localStorage !== 'undefined'

const getStoredFeedback = (): FeedbackStorageValue => {
  if (!isStorageAvailable()) return {}

  try {
    const stored = localStorage.getItem(FeedbackStorageKey)
    return stored ? JSON.parse(stored) : {}
  } catch (error) {
    logger.error('FeedbackStorage:getStoredFeedback:parseError', error)
    return {}
  }
}

const updateFeedback = (updates: Partial<FeedbackStorageValue>): void => {
  if (!isStorageAvailable()) return

  try {
    const current = getStoredFeedback()
    const newFeedback = { ...current, ...updates }
    localStorage.setItem(FeedbackStorageKey, JSON.stringify(newFeedback))
  } catch (error) {
    logger.error('FeedbackStorage:updateFeedback:saveError', error)
  }
}

export const FeedbackStorage = {
  getFeedback: (): FeedbackStorageValue => getStoredFeedback(),

  setFeedbackShow: (): void => {
    updateFeedback({ feedbackShown: true })
  },

  onWorkoutComplete: (): void => {
    updateFeedback({ workoutComplete: true })
  },

  onSingleGameplayComplete: (): void => {
    updateFeedback({ singleGameplayComplete: true })
  },
}
